module.exports = __webpack_public_path__ + "risk-3a8bd35cddd2170db761ab78c4914a6c.svg";